(function () {
  if (window.ModamobAuthReloadWorkaroundReady) return;

  window.ModamobAuthReloadWorkaroundReady = true;

  var mobileAuthQuery = window.matchMedia('(max-width: 1024px), (pointer: coarse)');
  var authResourcesWarmed = false;
  var lastAuthClick = 0;

  function shouldUseWorkaround() {
    return mobileAuthQuery.matches;
  }

  function addWarmupLink(rel, href, asValue) {
    var existing = document.querySelector('link[href="' + href + '"][rel="' + rel + '"]');
    var link;

    if (existing) return;

    link = document.createElement('link');
    link.rel = rel;
    link.href = href;

    if (asValue) link.as = asValue;
    if (rel === 'preconnect') link.crossOrigin = 'anonymous';

    document.head.appendChild(link);
  }

  function warmAuthResources() {
    if (authResourcesWarmed) return;
    authResourcesWarmed = true;

    addWarmupLink('dns-prefetch', 'https://shopify.com');
    addWarmupLink('dns-prefetch', 'https://cdn.shopify.com');
    addWarmupLink('dns-prefetch', 'https://shop.app');
    addWarmupLink('dns-prefetch', 'https://pay.shopify.com');
    addWarmupLink('preconnect', 'https://shopify.com');
    addWarmupLink('preconnect', 'https://cdn.shopify.com');
    addWarmupLink('preconnect', 'https://shop.app');
    addWarmupLink('preconnect', 'https://pay.shopify.com');
    addWarmupLink(
      'prefetch',
      'https://cdn.shopify.com/shopifycloud/customer-authentication-web/production/sprite-1b2b2c.svg',
      'image'
    );

    try {
      var sprite = new Image();
      sprite.decoding = 'async';
      sprite.src = 'https://cdn.shopify.com/shopifycloud/customer-authentication-web/production/sprite-1b2b2c.svg';
    } catch (imageError) {
    }

  }

  function pulseCurrentPage() {
    var pulse = document.createElement('div');
    var frame = 0;

    pulse.setAttribute('aria-hidden', 'true');
    pulse.style.cssText =
      'position:fixed;left:-1px;top:-1px;width:1px;height:1px;opacity:.01;pointer-events:none;' +
      'transform:translateZ(0);will-change:transform;';
    document.body.appendChild(pulse);

    function tick() {
      frame += 1;
      pulse.style.transform = 'translate3d(' + (frame % 2) + 'px,0,0)';
      document.documentElement.style.setProperty('--modamob-auth-pulse', String(frame));
      void pulse.offsetHeight;
      window.dispatchEvent(new Event('resize'));

      if (frame < 24) {
        window.requestAnimationFrame(tick);
        return;
      }

      pulse.remove();
      document.documentElement.style.removeProperty('--modamob-auth-pulse');
    }

    window.requestAnimationFrame(tick);
  }

  function keepAuthWindowActive(authWindow, targetUrl) {
    var pulses = 0;
    var interval = window.setInterval(function () {
      pulses += 1;

      try {
        authWindow.focus();
      } catch (focusError) {
      }

      if (pulses === 4 || pulses === 10) {
        try {
          authWindow.location.href = targetUrl;
        } catch (locationError) {
        }
      }

      if (!authWindow || authWindow.closed || pulses >= 16) {
        window.clearInterval(interval);
      }
    }, 350);
  }

  function forceAuthWindowRefresh(authWindow, targetUrl, delay) {
    window.setTimeout(function () {
      if (!authWindow || authWindow.closed) return;

      try {
        authWindow.focus();
      } catch (focusError) {
      }

      try {
        authWindow.location.reload();
      } catch (reloadError) {
        try {
          authWindow.location.replace(targetUrl);
        } catch (replaceError) {
          try {
            authWindow.location.href = targetUrl;
          } catch (locationError) {
          }
        }
      }
    }, delay);
  }

  function openLoginWithTiming(targetUrl) {
    var now = Date.now();
    var authWindow;

    if (!targetUrl) return true;
    if (now - lastAuthClick < 1000) return false;
    lastAuthClick = now;

    warmAuthResources();
    pulseCurrentPage();

    try {
      authWindow = window.open(targetUrl, 'modamob_customer_auth');
    } catch (openError) {
      authWindow = null;
    }

    if (!authWindow) {
      window.setTimeout(function () {
        window.location.assign(targetUrl);
      }, 120);
      return false;
    }

    try {
      authWindow.focus();
    } catch (focusError) {
    }

    keepAuthWindowActive(authWindow, targetUrl);
    forceAuthWindowRefresh(authWindow, targetUrl, 1800);
    forceAuthWindowRefresh(authWindow, targetUrl, 3600);

    return false;
  }

  window.ModamobAuthReloadWorkaround = function (event, link) {
    var targetUrl = link && (link.getAttribute('href') || link.dataset.authUrl);

    if (!shouldUseWorkaround()) return true;
    if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return true;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    return openLoginWithTiming(targetUrl);
  };

  window.ModamobAuthPrewarm = function () {
    if (!shouldUseWorkaround()) return true;

    warmAuthResources();
    pulseCurrentPage();

    return true;
  };

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[data-modamob-auth-workaround]');

      if (!link || !shouldUseWorkaround()) return;
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      window.ModamobAuthReloadWorkaround(event, link);
    },
    true
  );
})();
